import Vue from "vue";
import App from "./views/App.vue";
// eslint-disable-next-line
import "./registerServiceWorker.js";
import router from "./router.js";
import VueRouterPermissions from "vue-router-user-roles";
import { i18n } from "./general";
import { connectUser } from "./general";
import { addInterceptExpiredAccessToken } from "./general";

import BootstrapVue from "bootstrap-vue";
import "./general/scss/variables.scss";
import "./general/scss/theme.scss";
import * as api from "./general/api/pluginAPI";
import "./registerServiceWorker";

// Surcharge des paramètres de Axios; ne supporte pas la configuration par fichier

Vue.use(BootstrapVue);
Vue.use(VueRouterPermissions, { router });

Vue.config.productionTip = false;
Vue.prototype.$api = api;
addInterceptExpiredAccessToken(api, Vue.prototype.$user);
connectUser(api).then(user => {
  Vue.prototype.$user.set(user);

  new Vue({
    i18n,
    router,
    render: h => h(App)
  }).$mount("#app");
});
